<template>
  <div>
    <b-button
      v-permission="'products.create'"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="addNew">
      <feather-icon
        icon="PlusIcon"
        class="mr-50"/>
      <span class="align-middle">{{$t('AddNew')}}</span>
    </b-button>
    <Grid
      :service="service"
      route_name="products"
      order_column="name">
      <template v-slot:gridThead>
        <vs-th key="id" sort-key="id">ID</vs-th>
        <vs-th key="name" sort-key="name">{{ $t('product.name') }}</vs-th>
        <vs-th key="status" sort-key="status">{{ $t('product.status') }}</vs-th>
        <vs-th key="price" sort-key="price">{{ $t('product.price') }}</vs-th>
        <vs-th key="featured" v-permission="'home_highlights.edit'">{{ $t('product.featured') }}</vs-th>
      </template>
      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="5%" key="id">
            <div> {{ tr.id }} </div>
          </vs-td>
          <vs-td width="40%" key="name">
            <div> {{ tr.name }}</div>
          </vs-td>
          <vs-td width="15%" key="status">
            <vs-chip transparent :color="getStatusColor(_.get(tr, 'status'))" class="text-base">{{formatStatus(_.get(tr, 'status')) }}</vs-chip>
          </vs-td>
          <vs-td width="18%" key="price">
            <span> {{formatValue(_.get(tr, 'price')) }}</span>
          </vs-td>
          <vs-td width="12%" key="featured" v-permission="'home_highlights.edit'">
            <div class="featured-cell" :title="$t('product.featured_hint')">
              <input
                type="number"
                min="1"
                max="9999"
                class="featured-input"
                :value="tr.featured_order"
                placeholder="—"
                @keydown.enter.prevent="$event.target.blur()"
                @change="onFeaturedChange(tr, $event)">
              <feather-icon
                v-if="tr.featured_order"
                icon="XIcon"
                class="h-4 w-4 stroke-current text-danger cursor-pointer"
                :title="$t('Delete')"
                @click="saveFeatured(tr, null)"/>
              <feather-icon
                v-else
                icon="StarIcon"
                class="h-4 w-4 stroke-current text-secondary"/>
            </div>
          </vs-td>
          <vs-td width="10%">
            <div class="flex flex-row gap-2">
              <feather-icon
                v-permission="'products.edit'"
                icon="EditIcon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
                @click="props.edit(props.data[indextr].id)"/>
              <feather-icon
                v-permission="'products.delete'"
                icon="Trash2Icon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
                @click="props.destroy(props.data[indextr])"/>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'


import ProductService from '@/services/api/ProductService'

import { currencyFormatter } from '@/util/Util'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton
  },
  data: () => ({
    selected: [],
    service: null
  }),
  methods: {
    addNew() {
      this.$router.push('/products/create')
    },
    formatValue(value){
      return currencyFormatter(value)
    },
    formatStatus(stt){
      return this.$t('product.status_.'+stt)
    },
    getStatusColor(stt){
      switch (stt) {
        case ('CR'):
          return 'default'
          break;
        case ('ED'):
          return 'warning'
          break;
        case ('RE'):
          return 'success'
        case ('DI'):
          return 'danger'
          break;
        default:
          break;
      }
    },
    onFeaturedChange(tr, event) {
      const raw = String(event.target.value).trim()
      const value = raw === '' ? null : Number(raw)

      if (value !== null && (!Number.isInteger(value) || value < 1 || value > 9999)) {
        event.target.value = tr.featured_order || ''
        return
      }

      this.saveFeatured(tr, value, event.target)
    },
    saveFeatured(tr, value, inputEl = null) {
      const previous = tr.featured_order === undefined ? null : tr.featured_order
      if (value === previous) return

      this.service.setFeaturedOrder(tr.id, value).then(
        response => {
          this.$set(tr, 'featured_order', response.featured_order)
          if (inputEl) inputEl.value = response.featured_order === null ? '' : response.featured_order
          this.notifySuccess(this.$vs, this.$t('product.featured_saved'))
        },
        () => {
          if (inputEl) inputEl.value = previous === null ? '' : previous
          this.notifyError(this.$vs, this.$t('messages.error'))
        }
      )
    }
  },
  beforeMount() {
    this.service = ProductService.build(this.$vs)
  }
}
</script>

<style lang="scss" scoped>
.featured-cell {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.featured-input {
  width: 58px;
  padding: 0.3rem 0.45rem;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  font-size: 0.85rem;
  text-align: center;

  &::placeholder {
    color: rgba(0, 0, 0, 0.3);
  }
}
</style>
